export const SHOW_NOTIFICATION = '@notify_SHOW_NOTIFICATION';
export const HIDE_NOTIFICATION = '@notify_HIDE_NOTIFICATION';
export const REMOVE_ALL_NOTIFICATIONS = '@notify_REMOVE_ALL_NOTIFICATIONS';


// WEBPACK FOOTER //
// ./src/common/notify/actionTypes.js